import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

export const BookingConfirmContainer = styled(Box)(({ theme }) => ({
  background: theme.palette.blue?.backgroundCard || '#F3F8FE',
  borderRadius: 10,
  padding: theme.spacing(1, 0, 1, 0),
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(3),
  },
  marginBottom: theme.spacing(10),
}));

export const BookingInfoBox = styled(Box)(({ theme }) => ({
  background: 'transparent',
  borderRadius: 10,
  padding: theme.spacing(2),
  marginBottom: theme.spacing(2),
  [theme.breakpoints.up('xs')]: {
    marginBottom: theme.spacing(0),
  },
}));

export const PaymentInfoBox = styled(Box)(({ theme }) => ({
  background: theme.palette.common.white,
  borderRadius: 10,
  paddingInline: theme.spacing(2),
  paddingBlock: theme.spacing(4),
  boxShadow: theme.shadows[1],
}));

export const BookingTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  marginBottom: theme.spacing(3),
  fontSize: 24,
}));

export const PaymentTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  marginBottom: theme.spacing(3),
  fontSize: 24,
}));

export const BookingInfoRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'start',
  alignItems: 'center',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

export const PaymentSummaryRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(1),
}));

export const PaymentTotalRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  margin: `${theme.spacing(2)} 0`,
}));

export const PaymentMethodTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  marginBottom: theme.spacing(4),
  fontSize: 18,
}));

export const PaymentConfirmButton = styled(Button)(({ theme }) => ({
  background: '#C2883A',
  color: '#fff',
  borderRadius: 999,
  height: 56,
  fontWeight: 700,
  fontSize: 18,
  marginTop: theme.spacing(2),
  '&:hover': {
    background: '#a06a23',
  },
}));

export const TourDetailInfomationDetailSection = styled(Box)(({ theme }) => ({
  display: 'block',
  justifyContent: 'start',
  alignItems: 'center',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

export const TourDetailBookingInfoTypeContainer = styled(Box)(({ theme }) => ({
  display: 'block',
  justifyContent: 'start',
  alignItems: 'center',
  gap: theme.spacing(1),
  marginBottom: theme.spacing(2),
  borderBottom: `1px solid ${theme.palette.other.lightSlate}`,
}));

export const TourDetailBookingInfoChild = styled(Box)(({ theme }) => ({
  display: 'block',
  justifyContent: 'start',
  alignItems: 'center',
  gap: theme.spacing(1),
  marginBottom: theme.spacing(2),
}));

export const TourDetailBookingInfoTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  marginBottom: theme.spacing(2),
  fontSize: 18,
}));
